import React from 'react';
import Text from 'components/Text/Text';
import { ImportantMessagesField } from './components/ImportantMessagesField';
import { InformationMessagesField } from './components/InformationMessagesField';
import style from './AndroidWatchesTab.module.scss';

export const AndroidWatchesTab: React.FC = () => {
	return (
		<div className={style.container} data-test="AndroidWatchesTab">
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="messagesHeading"
					theme="secondary"
					size="l"
					weight="bold"
					display="inline"
				/>
				<div>
					<ImportantMessagesField />
					<InformationMessagesField />
				</div>
			</div>
		</div>
	);
};
